import { getCurrentUrlWithoutHash } from '../useCurrentRoute';

export const RETURN_URL_PARAM = 'returnUrl';

function getReturnUrl(url: string, publicUrl?: string): string {
    const currentUrl = getCurrentUrlWithoutHash();
    const [path, query] = currentUrl.split('?');
    let normalizedPath = path;
    if (publicUrl) {
        normalizedPath = path.replace(publicUrl, '');
    }
    const params = new URLSearchParams(query);
    const existingReturnUrl = params.get(RETURN_URL_PARAM);

    /**
     * Solves double call issue, which would otherwise result in multiple returnUrl in the url.
     * With this check, the function is idempotent
     */
    if (existingReturnUrl && normalizedPath === url) {
        return existingReturnUrl;
    }

    return `${normalizedPath}?${params}`.replace(/\?$/, '');
}

export function wrapUrlWithReturnUrl<T extends string>(url: T, publicUrl?: string): T {
    const [path, query] = url.split('?');
    const params = new URLSearchParams(query);

    params.set(RETURN_URL_PARAM, getReturnUrl(url, publicUrl));

    return `${path}?${params}` as T;
}

export function readReturnUrl(): string | undefined {
    const currentUrl = getCurrentUrlWithoutHash();
    const [, query] = currentUrl.split('?');
    const params = new URLSearchParams(query);

    return params.get(RETURN_URL_PARAM) ?? undefined;
}
export function removeReturnUrl(): void {
    const [hash, query] = window.location.hash.split('?');
    const params = new URLSearchParams(query);
    params.delete(RETURN_URL_PARAM);
    window.location.hash = `${hash}?${params}`;
}
